export const text = "#000000";
export const hover = "#000000";
export const title = `Cammron, Euclid Square, Arial, Helvetica, freesans, sans-serif `;
export const paragraph = `Helvetica, Euclid Square, Arial, Helvetica, freesans, sans-serif `;
